<template>
  <cell :class="['bcq-macos-dock-open-app-indicator-container']" y-align="middle" x-align="center">
    <div :class="['rounded-full', 'bg-white', 'bcq-macos-dock-open-app-indicator', 'opacity-50', open ? null : 'invisible']" />
  </cell>
</template>
<script>
export default {
  name: 'MacosDockAppMarker',
  props: {
    open: {
      type: Boolean
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/macos-dock-app-marker/macos-dock-app-marker.vue